import { IComponent } from '@eventr/common'
import { Stack } from '@mui/material'
import { ComponentFinder } from '../componentFinder'

interface IIteratorProps {
    data: any
    renderOptions: IIteratorOptions
    past?: boolean
}
interface IIteratorOptions {
    components: IComponent[]
    value: string
    spacing?: string
}
export const Iterator = ({ data, renderOptions, past }: IIteratorProps) => {
    const renderComponents = (d: any) => {
        return renderOptions?.components.map((c, i) => {
            return (
                <ComponentFinder
                    key={i}
                    data={d}
                    renderOptions={c}
                    componentKey={c.componentKey}
                    parentData={data}
                    isInPast={past}
                />
            )
        })
    }
    return (
        <>
            {renderOptions.value.length > 0 && (
                <Stack direction="column" spacing={renderOptions.spacing ?? 0}>
                    {data[renderOptions.value] &&
                        data[renderOptions.value].map((d: any) => {
                            return renderComponents(d)
                        })}
                </Stack>
            )}
        </>
    )
}
